import jsPDF from 'jspdf';
import toast from 'react-hot-toast';
import { datosAdmin, marcasBasePuntos25WA, marcasBasePuntos50WA } from './administrador';
import "../fonts/Inter_18pt-Light-normal";
import "../fonts/Inter_18pt-Bold-normal";
import "../fonts/Inter_18pt-Regular-normal";
import { diccionarioEsAEn } from './diccionario';

const clubPropietario = datosAdmin.nombre;

function convertirA12Horas(hora24) {
  if (!hora24) return "";
  
  let [horas, minutos] = hora24.split(":").map(Number);
  
  const ampm = horas >= 12 ? "PM" : "AM";
  horas = horas % 12 || 12;
  
  return `${horas}:${minutos.toString().padStart(2, "0")} ${ampm}`;
}

export async function revisarUrl(url) {
  if(url){
    if(url !== ''){
      const response = await fetch(url);
      return response.ok;
    }else{
      return false;
    }
  }else{
    return false;
  }
}

export function tiempoAsegundos(tiempoStr) {
  const partes = tiempoStr.split(':');
  
  if (partes.length !== 3) {
    throw new Error("El formato del tiempo debe ser MM:SS:MS");
  }

  const minutos = parseInt(partes[0]);
  const segundos = parseInt(partes[1]);
  const centesimas = parseInt(partes[2]);

  return minutos * 60 + segundos + centesimas / 100;
}

export function calcularPuntosWorldAquatics(tiempoStr, genero, prueba, piscina) {
  const tiempoReal = tiempoAsegundos(tiempoStr);
  let tiempoBase = 0;

  if(piscina === '25'){
    const sacarGenero = marcasBasePuntos25WA.filter((marca)=> marca.genero === genero);
    if(sacarGenero.length !== 0){
      const auxPruebas = sacarGenero[0].pruebas;
      const buscarPruebas = auxPruebas.filter((prue)=>prue.prueba === prueba);
      if(buscarPruebas.length !== 0){
        tiempoBase = buscarPruebas[0].marcaBase;
      }else{
        return 0;
      }
    }else{
      return 0;
    }
  }else if(piscina === '50'){
    const sacarGenero = marcasBasePuntos50WA.filter((marca)=> marca.genero === genero);
    if(sacarGenero.length !== 0){
      const auxPruebas = sacarGenero[0].pruebas;
      const buscarPruebas = auxPruebas.filter((prue)=>prue.prueba === prueba);
      if(buscarPruebas.length !== 0){
        tiempoBase = buscarPruebas[0].marcaBase;
      }else{
        return 0;
      }
    }else{
      return 0;
    }
  }else{
    return 0;
  }

  if (tiempoReal <= 0 || tiempoBase <= 0) {
    return 0;
  }

  const puntos = 1000 * Math.pow(tiempoBase / tiempoReal, 3);

  // Si es entero, lo dejamos así, si no, redondeamos a 2 decimales
  return Number.isInteger(puntos) ? puntos : parseFloat(puntos.toFixed(2));
}

export function arreglarTiempoEstandar(time){
  const auxTiemposSeparados = time.split(':');
  const minutos = parseInt(auxTiemposSeparados[0]);
  const segundos = parseInt(auxTiemposSeparados[1]);
  const milisegundos = parseInt(auxTiemposSeparados[2]);
  if(minutos !== 0){
    return minutos + ':' + (segundos < 10 && segundos !== 0 ? '0' + segundos : segundos) + '.' + (milisegundos < 10 && milisegundos !== 0 ? '0' + milisegundos : milisegundos);
  }else{
    return (segundos < 10 && segundos !== 0 ? '0' + segundos : segundos) + '.' + (milisegundos < 10 && milisegundos !== 0 ? '0' + milisegundos : milisegundos);
  }
}

function acortarNombreClub(nombreCompleto, cantidadCaracteres) {
  // Eliminar espacios al inicio y al final del nombre completo
  nombreCompleto = nombreCompleto.trim();

  // Tomar la cantidad especificada de caracteres
  const nombreAcortado = nombreCompleto.slice(0, cantidadCaracteres);

  return nombreAcortado;
}

function sacarRecordDePrueba(prueba, genero, records){
  let record = null;

  if(genero === 'Femenino' || genero === 'Masculino'){
    record = records.find(rec => rec.prueba === prueba && rec.genero === genero);
  }

  return record;
}

export function pdfPlanilla(planilla, setPdfUrl, detallesTorneo, pruebasCompletas, usuario, llamados, marcarLinea, color, recordsMundial, recordsNacional, recordsEvento, idioma) {
  const auxProgramacion = toast.loading('Creando programación...\nPor favor espera unos segundos.');
  setTimeout(function() {
    const doc = new jsPDF({
      format: 'letter',
      compress: true,
    });
    const logoImg = new Image();
    const qrResultados = new Image();
    const qrResultadosPws = new Image();
    const logoImgPws = new Image();
    const marco = new Image();
    const siluetas = new Image();
    logoImg.src = require('../img/img_logo.png');
    qrResultados.src = require('../img/qr-resultados.png');
    qrResultadosPws.src = require('../img/qr-resultados-pws.png');
    logoImgPws.src = require('../img/img-logo-factura.png');
    marco.src = require('../img/img-marco.png');
    siluetas.src = require('../img/img-siluetas.png');
    const width = 22;
    const height = 22;
    const columnWidth = doc.internal.pageSize.width / 3;
    let x = 10;
    let y = 30;
  
    if (planilla.length === 0) {
      doc.setFontSize(11);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(usuario.nombreclub + '\nLa programación aún no se ha registrado.', doc.internal.pageSize.width / 2, 48, { align: 'center' });
    } else {
      let newPage = false;
      pruebasCompletas.forEach((obj, indexObj) => {
        const agregarCabecera = () => {
          doc.setTextColor('black');
          doc.setFontSize(15);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.addImage(marco, 'png', 0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height);
          doc.text(`${doc.getNumberOfPages() < 10 ? '0' + doc.getNumberOfPages() : doc.getNumberOfPages()}`, 178, 25);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.setFontSize(11);
          doc.addImage(logoImg, 'png', 20, 3, width, height);
          doc.addImage(logoImgPws, 'png', 185, 10, 16, 15);
          doc.text(`${detallesTorneo.titulo !== '' ? detallesTorneo.titulo : ''}\n${clubPropietario}`, doc.internal.pageSize.width / 2, 10, { align: 'center' });
          doc.setFontSize(8);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(`${detallesTorneo.direccion}\n${detallesTorneo.jornadas[indexObj].fecha}`, doc.internal.pageSize.width / 2, 18, { align: 'center' });
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.setFontSize(10);
          doc.text((idioma === 'ingles' ? diccionarioEsAEn['Jornada'] + ' ' : 'Jornada ') + (indexObj + 1), doc.internal.pageSize.width / 2, 25, { align: 'center' });
          doc.text((idioma === 'ingles' ? diccionarioEsAEn['Calentamiento'] + ' ' : 'Calentamiento: ') + (convertirA12Horas(detallesTorneo.jornadas[indexObj].calentamiento)), doc.internal.pageSize.width / 3, 25, { align: 'center' });
          doc.text((idioma === 'ingles' ? diccionarioEsAEn['Competencia'] + ' ' : 'Competencia: ') + (convertirA12Horas(detallesTorneo.jornadas[indexObj].inicio)), doc.internal.pageSize.width / 1.5, 25, { align: 'center' });
          doc.line(20, 26, 203, 26);
          //doc.line(25, 270, 190, 270);
          doc.setFontSize(10);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(idioma === 'ingles' ? diccionarioEsAEn['resultados'] : `resultados`, 14.5, 275, { angle: 90 });
          doc.text(idioma === 'ingles' ? diccionarioEsAEn['resultados'] : `resultados`, 33.5, 258.5, { angle: -90 });
          doc.addImage(qrResultados, 'png', 15, 258, 18, 18);
          doc.setFontSize(8);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(`www.prowebsports.com.co`, 62, 275)
          //doc.text(`PROWEBSPORTS`, 84, 273)
          doc.text(`+57 324-588-4041`, 65, 272)
          //doc.text(`pws@prowebsports.com.co`, 159, 273)
          doc.addImage(siluetas, 'png', 35, 255, 140, 20);
          doc.addImage(logoImg, 'png', 175, 260, 15, 15);
        };
        if (newPage) {
          doc.addPage(); // Agregar una nueva página si es necesario
          newPage = false; // Restablecer la variable
          x = 10; // Restablecer la posición X
          y = 30;
        }
        agregarCabecera();
        obj.forEach((prue, indexPrue)=>{
          let quitarEspacio = true;
          doc.setTextColor('black');
          doc.setFontSize(10.5);
          doc.setFont('Inter_18pt-Regular', 'normal');
          const text = `${prue.id} ${idioma === 'ingles' && diccionarioEsAEn[prue.categoria] ? diccionarioEsAEn[prue.categoria] : prue.categoria}`;
          const textPrueba = `${idioma === 'ingles' && diccionarioEsAEn[prue.prueba.prueba] ? diccionarioEsAEn[prue.prueba.prueba] : prue.prueba.prueba}`;
          doc.setFontSize(7.3);
          doc.setFont('Inter_18pt-Light', 'normal');
          let auxRecords = ``;
          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsEvento.filter(re => re.piscina === detallesTorneo.piscina))){
            auxRecords += `RE:${arreglarTiempoEstandar(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsEvento.filter(re => re.piscina === detallesTorneo.piscina)).record)} ~ `;
          }

          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsMundial)){
            auxRecords += `RM:${arreglarTiempoEstandar(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsMundial).record)} ~ `
          }

          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsNacional)){
            auxRecords += `RN:${arreglarTiempoEstandar(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsNacional).record)}`;
          }

          
          if (y >= doc.internal.pageSize.height - 32) {
            // Cambiar a la siguiente columna o página
            x += columnWidth;
            y = 30;
    
            if (x >= columnWidth * 3) {
              doc.addPage();
              agregarCabecera();
              x = 10;
            }
  
            if(x >= columnWidth * 1 && x <= columnWidth * 2){
              x -= 5;
            }
            if(x >= columnWidth * 2 && x <= columnWidth * 3){
              x -= 4;
            }
          }
          
          doc.setFontSize(10.5);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.text(x + 29, y, text, {align: 'center'});
          doc.text(x + 29, y + 4.5, textPrueba, {align: 'center'});
          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsEvento.filter(re => re.piscina === detallesTorneo.piscina)) || sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsMundial) || sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsNacional)){
            doc.setFontSize(7.3);
            doc.setFont('Inter_18pt-Regular', 'normal');
            doc.text(x + 29, y + 7.5, auxRecords, {align: 'center'});
            y += 2
          }
          if(quitarEspacio){
            y += 10;
          }else{
            y += 11;
          }
          // Itera sobre los nadadores en el arreglo `data`
          planilla[prue.id - 1].forEach((nadador, indexNadador) => {
            doc.setTextColor('black');
            doc.setFontSize(7.5);
            doc.setFont('Inter_18pt-Regular', 'normal');
            const textSerie = idioma === 'ingles' ? `${diccionarioEsAEn['Serie']} #${nadador.Serie}` : `Serie #${nadador.Serie}`;
    
            if ((y + (20 + (nadador.nadadores.length))) >= doc.internal.pageSize.height - 20) {
              // Cambiar a la siguiente columna o página
              x += columnWidth;
              y = 30;
    
              if (x >= columnWidth * 3) {
                doc.addPage();
                agregarCabecera();
                x = 10;
              }
  
              if(x >= columnWidth * 1 && x <= columnWidth * 2){
                x -= 5;
              }
              if(x >= columnWidth * 2 && x <= columnWidth * 3){
                x -= 4;
              }
            }
            doc.setFontSize(8);
            doc.setFont('Inter_18pt-Regular', 'normal');
            doc.text(x, y - 1.5, textSerie);
            y += 1.5;
            nadador.nadadores.forEach((nadador, indexNadador) => {
              quitarEspacio = false;
              doc.setFontSize(7.3);
              doc.setFont('Inter_18pt-Light', 'normal');
              const carril = `${nadador.carril}.`;
              const nombreNadador = `${acortarNombreClub(nadador.nombre.toString(), 28)}`;
              const tiempo = `${!llamados ? nadador.record ? arreglarTiempoEstandar(nadador.record) : '' : ''}`;
              const club = `${!llamados ? nadador.club.toString().toLowerCase() : acortarNombreClub(nadador.nombreclub.toString().toLowerCase(), 17)}`;
              const edad = `${!llamados ? nadador.edad[0] ? nadador.edad[0] < 10 ? '0' + nadador.edad[0] : nadador.edad[0] : '' : ''}`;
  
              if (y >= doc.internal.pageSize.height - 32) {
                // Cambiar a la siguiente columna o página
                x += columnWidth;
                y = 30;
    
                if (x >= columnWidth * 3) {
                  doc.addPage();
                  agregarCabecera();
                  x = 10;
                }
  
                if(x >= columnWidth * 1 && x <= columnWidth * 2){
                  x -= 5;
                }
                if(x >= columnWidth * 2 && x <= columnWidth * 3){
                  x -= 4;
                }
  
              }
              if(marcarLinea && usuario.nombreclub === nadador.nombreclub[0]){
                const padding = 1; // Espacio de relleno alrededor del texto
                const textWidth = 56 + tiempo.length;
                const textHeight = 3.7; // Altura aproximada del texto
                // Definir el color de resaltado (en formato RGB)
                doc.setFillColor(color.r, color.g, color.b);
                // Dibujar un rectángulo detrás del texto
                doc.rect(x - padding, y - textHeight + padding, textWidth + padding * 2, textHeight, 'F');
              }
              doc.setFontSize(7.3);
              doc.setTextColor('black');
              doc.setFont('Inter_18pt-Regular', 'normal');
              doc.text(x, y, carril);
              doc.setFont('Inter_18pt-Light', 'normal');
              doc.text(nombreNadador, x + 2.3, y, {align: 'left'});
              if(!nadador.equipo){
                doc.text(edad, x + 43, y, {align: 'left'});
                doc.text(club, !llamados ? x + 47 : x + 43.4, y, {align: 'left'});
              }
              doc.text(tiempo, x + 55, y, {align: 'left'});
              y += 3.1;

              (nadador.equipo && !nadador.ocultar) && (
                nadador.equipo.forEach((eq, indexEq) =>{
                  doc.setFontSize(7.3);
                  doc.setFont('Inter_18pt-Light', 'normal');
                  const deportista = eq
                  const edadDeport = `${!llamados ? nadador.edades[indexEq] ? nadador.edades[indexEq] < 10 ? '0' + nadador.edades[indexEq] : nadador.edades[indexEq] : '' : ''}`;

                  if (y >= doc.internal.pageSize.height - 20) {
                    // Cambiar a la siguiente columna o página
                    x += columnWidth;
                    y = 30;
    
                    if (x >= columnWidth * 3) {
                      doc.addPage();
                      agregarCabecera();
                      x = 10;
                    }
  
                    if(x >= columnWidth * 1 && x <= columnWidth * 2){
                      x -= 5;
                    }
                    if(x >= columnWidth * 2 && x <= columnWidth * 3){
                      x -= 4;
                    }
  
                  }
                  doc.setFontSize(7.3);
                  doc.setFont('Inter_18pt-Light', 'normal');
                  doc.setTextColor('black');
                  doc.text(deportista, !llamados ? x + 6.3 : x + 2.5 , y, {align: 'left'});
                  doc.text(edadDeport, x + 2.5, y, {align: 'left'});
                  y += 3;
                })
              )
            });
            y += 2;
          });
        })
        if (indexObj < pruebasCompletas.length - 1) {
          doc.addPage(); // Agregar una nueva página si no es la última planilla
          newPage = false; // Restablecer la variable
          x = 10; // Restablecer la posición X // Agregar una nueva página si no es la última planilla
          y = 30;
        }
      });
        
      doc.setProperties({
        title: "Programación " + clubPropietario
      });
    }
  
    const generatedPdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(generatedPdfBlob);
    setPdfUrl(pdfUrl);
    toast.dismiss(auxProgramacion);
    toast.success('Programación creada correctamente.');
  }, 500);
}

export function pdfPlanillaCronosports(planilla, setPdfUrl, detallesTorneo, pruebasCompletas, usuario, marcarLinea, color, recordsMundial, recordsNacional, recordsEvento, idioma) {
  const doc = new jsPDF({
    format: 'letter',
      compress: true,
  });
  const logoImg = new Image();
  const qrResultados = new Image();
  const qrResultadosPws = new Image();
  const logoImgPws = new Image();
  const marco = new Image();
  const siluetas = new Image();
  logoImg.src = require('../img/img_logo.png');
  qrResultados.src = require('../img/qr-resultados.png');
  qrResultadosPws.src = require('../img/qr-resultados-pws.png');
  logoImgPws.src = require('../img/img-logo-factura.png');
  marco.src = require('../img/img-marco.png');
  siluetas.src = require('../img/img-siluetas.png');
  const width = 22;
  const height = 22;
  const columnWidth = doc.internal.pageSize.width / 3;
  let x = 10;
  let y = 30;

  if (planilla.length === 0) {
    doc.setFontSize(11);
    doc.setFont('Inter_18pt-Regular', 'normal');
    doc.text(usuario.nombreclub + '\nLa programación aún no se ha registrado.', doc.internal.pageSize.width / 2, 48, { align: 'center' });
  } else {
    let newPageCarril = 0;
    for (let i = 0; i < parseInt(detallesTorneo.carril); i++) {
      let newPage = false;
      if(i > 0 || newPageCarril !== i){
        doc.addPage();
        x = 10;
        y = 30;
      }
      pruebasCompletas.forEach((obj, indexObj) => {
        const agregarCabecera = () => {
          doc.setTextColor('black');
          doc.setFontSize(15);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.addImage(marco, 'png', 0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height);
          doc.text(`${doc.getNumberOfPages() < 10 ? '0' + doc.getNumberOfPages() : doc.getNumberOfPages()}`, 178, 25);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.setFontSize(11);
          doc.addImage(logoImg, 'png', 20, 3, width, height);
          doc.addImage(logoImgPws, 'png', 185, 10, 16, 15);
          doc.text(`${detallesTorneo.titulo !== '' ? detallesTorneo.titulo : ''}\n${clubPropietario}`, doc.internal.pageSize.width / 2, 10, { align: 'center' });
          doc.setFontSize(8);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(`${detallesTorneo.direccion}\n${detallesTorneo.jornadas[indexObj].fecha}`, doc.internal.pageSize.width / 2, 18, { align: 'center' });
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.setFontSize(10);
          doc.text((idioma === 'ingles' ? diccionarioEsAEn['Jornada'] + ' ' : 'Jornada ') + (indexObj + 1), doc.internal.pageSize.width / 2, 25, { align: 'center' });
          doc.text((idioma === 'ingles' ? diccionarioEsAEn['Calentamiento'] + ' ' : 'Calentamiento: ') + (convertirA12Horas(detallesTorneo.jornadas[indexObj].calentamiento)), doc.internal.pageSize.width / 3, 25, { align: 'center' });
          doc.text((idioma === 'ingles' ? diccionarioEsAEn['Competencia'] + ' ' : 'Competencia: ') + (convertirA12Horas(detallesTorneo.jornadas[indexObj].inicio)), doc.internal.pageSize.width / 1.5, 25, { align: 'center' });
          doc.line(20, 26, 203, 26);
          //doc.line(25, 270, 190, 270);
          doc.setFontSize(10);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(idioma === 'ingles' ? diccionarioEsAEn['resultados'] : `resultados`, 14.5, 275, { angle: 90 });
          doc.text(idioma === 'ingles' ? diccionarioEsAEn['resultados'] : `resultados`, 33.5, 258.5, { angle: -90 });
          doc.addImage(qrResultados, 'png', 15, 258, 18, 18);
          doc.setFontSize(8);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(`www.prowebsports.com.co`, 62, 275)
          //doc.text(`PROWEBSPORTS`, 84, 273)
          doc.text(`+57 324-588-4041`, 65, 272)
          //doc.text(`pws@prowebsports.com.co`, 159, 273)
          doc.addImage(siluetas, 'png', 35, 255, 140, 20);
          doc.addImage(logoImg, 'png', 175, 260, 15, 15);
        };
        if (newPage) {
          doc.addPage(); // Agregar una nueva página si es necesario
          newPage = false; // Restablecer la variable
          x = 10; // Restablecer la posición X
          y = 30;
        }
        agregarCabecera();
        obj.forEach((prue, indexPrue)=>{
          let quitarEspacio = true;
          doc.setTextColor('black');
          doc.setFontSize(10.5);
          doc.setFont('Inter_18pt-Regular', 'normal');
          const text = `${prue.id} ${idioma === 'ingles' && diccionarioEsAEn[prue.categoria] ? diccionarioEsAEn[prue.categoria] : prue.categoria}`;
          const textPrueba = `${idioma === 'ingles' && diccionarioEsAEn[prue.prueba.prueba] ? diccionarioEsAEn[prue.prueba.prueba] : prue.prueba.prueba}`;
          doc.setFontSize(7.3);
          doc.setFont('Inter_18pt-Light', 'normal');
          let auxRecords = ``;
          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsEvento.filter(re => re.piscina === detallesTorneo.piscina))){
            auxRecords += `RE:${arreglarTiempoEstandar(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsEvento.filter(re => re.piscina === detallesTorneo.piscina)).record)} ~ `;
          }

          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsMundial)){
            auxRecords += `RM:${arreglarTiempoEstandar(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsMundial).record)} ~ `
          }

          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsNacional)){
            auxRecords += `RN:${arreglarTiempoEstandar(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsNacional).record)}`;
          }

          if (y >= doc.internal.pageSize.height - 32) {
            // Cambiar a la siguiente columna o página
            x += columnWidth;
            y = 30;
      
            if (x >= columnWidth * 3) {
              doc.addPage();
              agregarCabecera();
              x = 10;
            }
  
            if(x >= columnWidth * 1 && x <= columnWidth * 2){
              x -= 5;
            }
            if(x >= columnWidth * 2 && x <= columnWidth * 3){
              x -= 4;
            }
          }
    
          doc.setFontSize(10.5);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.text(x + 29, y, text, {align: 'center'});
          doc.text(x + 29, y + 4.5, textPrueba, {align: 'center'});
          if(sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsEvento.filter(re => re.piscina === detallesTorneo.piscina)) || sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsMundial) || sacarRecordDePrueba(prue.prueba.prueba, prue.genero, recordsNacional)){
            doc.setFontSize(7.3);
            doc.setFont('ABeeZee-Regular', 'normal');
            doc.text(x + 29, y + 7.5, auxRecords, {align: 'center'});
            y += 2
          }
          if(quitarEspacio){
            y += 10;
          }else{
            y += 11;
          }
          // Itera sobre los nadadores en el arreglo `data`
          planilla[prue.id - 1].forEach((nadador, indexNadador) => {
            doc.setTextColor('black');
            doc.setFontSize(8);
            doc.setFont('Inter_18pt-Regular', 'normal');
            const textSerie = idioma === 'ingles' ? `${diccionarioEsAEn['Serie']} #${nadador.Serie}` : `Serie #${nadador.Serie}`;
    
            if (y >= doc.internal.pageSize.height - 32) {
              // Cambiar a la siguiente columna o página
              x += columnWidth;
              y = 30;
    
              if (x >= columnWidth * 3) {
                doc.addPage();
                agregarCabecera();
                x = 10;
              }
  
              if(x >= columnWidth * 1 && x <= columnWidth * 2){
                x -= 5;
              }
              if(x >= columnWidth * 2 && x <= columnWidth * 3){
                x -= 4;
              }
            }
            doc.setFontSize(8);
            doc.setFont('Inter_18pt-Regular', 'normal');
            doc.text(x, y - 1.5, textSerie);
            y += 4;
            nadador.nadadores.forEach((nadador, indexNadador) => {
              if(indexNadador === i){
                quitarEspacio = false;
                doc.setFontSize(7.5);
                doc.setFont('Inter_18pt-Light', 'normal');
                const carril = `${nadador.carril}:`;
                const nombreNadador = `${nadador.nombre}`;
                const lineasTiempo = `_________________`;
    
                if (y >= doc.internal.pageSize.height - 32) {
                  // Cambiar a la siguiente columna o página
                  x += columnWidth;
                  y = 30;
      
                  if (x >= columnWidth * 3) {
                    doc.addPage();
                    agregarCabecera();
                    x = 10;
                  }
    
                  if(x >= columnWidth * 1 && x <= columnWidth * 2){
                    x -= 5;
                  }
                  if(x >= columnWidth * 2 && x <= columnWidth * 3){
                    x -= 4;
                  }
    
                }
                if(marcarLinea && usuario.nombreclub === nadador.nombreclub[0]){
                  const padding = 1; // Espacio de relleno alrededor del texto
                  const textWidth = 56 + 0;
                  const textHeight = 3.7; // Altura aproximada del texto
                  // Definir el color de resaltado (en formato RGB)
                  doc.setFillColor(color.r, color.g, color.b);
                  // Dibujar un rectángulo detrás del texto
                  doc.rect(x - padding, y - textHeight + padding, textWidth + padding * 2, textHeight, 'F');
                }
                doc.setFontSize(7.5);
                doc.setTextColor('black');
                doc.setFont('Inter_18pt-Regular', 'normal');
                doc.text(x, y, carril);
                doc.setFont('Inter_18pt-Light', 'normal');
                doc.text(nombreNadador, x + 24, y, {align: 'left'});
                doc.text(lineasTiempo, x + 2.5, y, {align: 'left'});
                y += 4;
              }
            });
            y += 2;
          });
        })
        if (indexObj < pruebasCompletas.length - 1) {
          doc.addPage(); // Agregar una nueva página si no es la última planilla
          newPage = false; // Restablecer la variable
          x = 10; // Restablecer la posición X // Agregar una nueva página si no es la última planilla
          y = 30;
        }
      });
    }
      
    doc.setProperties({
      title: "Programación Papeletas CRONO" + clubPropietario
    });
  }

  const generatedPdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(generatedPdfBlob);
  setPdfUrl(pdfUrl);
}

export function pdfTiempos(resultados, setPdfUrl, detallesTorneo, usuario, nPrueba, nPuestos){
  const auxTiempos = toast.loading('Resultados a formato PDF...\nPor favor espera unos segundos.');
  setTimeout(function() {
    const index = resultados.findIndex(obj => obj.id === parseFloat(parseFloat(nPrueba - 1).toFixed(1)));
    const data = index === -1 ? resultados : resultados.slice(index);
    const doc = new jsPDF({
      format: 'letter',
      compress: true,
    });
    const logoImg = new Image();
    const qrResultados = new Image();
    const qrResultadosPws = new Image();
    const logoImgPws = new Image();
    const marco = new Image();
    const siluetas = new Image();
    logoImg.src = require('../img/img_logo.png');
    qrResultados.src = require('../img/qr-resultados.png');
    qrResultadosPws.src = require('../img/qr-resultados-pws.png');
    logoImgPws.src = require('../img/img-logo-factura.png');
    marco.src = require('../img/img-marco.png');
    siluetas.src = require('../img/img-siluetas.png');
    const width = 22;
    const height = 22;
    const columnWidth = doc.internal.pageSize.width / 3;
    
    let x = 10;
    let y = 30;
  
    if(data.length === 0){
      doc.setFontSize(11);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(usuario.nombreclub + '\nSi aun no puedes ver los tiempos, es posible que el torneo de ' + clubPropietario + ' aún no empieza.', doc.internal.pageSize.width / 2, 38, { align: 'center' });
    }

    const agregarCabecera = () => {
      doc.setFontSize(15);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.addImage(marco, 'png', 0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height);
      doc.text(`${doc.getNumberOfPages() < 10 ? '0' + doc.getNumberOfPages() : doc.getNumberOfPages()}`, 178, 25);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.setFontSize(11);
      doc.addImage(logoImg, 'png', 20, 3, width, height);
      doc.addImage(logoImgPws, 'png', 185, 10, 16, 15);
      doc.text(`${detallesTorneo.titulo}\n${clubPropietario}`, doc.internal.pageSize.width / 2, 10, { align: 'center' });
      doc.setFontSize(8);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(`${detallesTorneo.direccion}\nResultados`, doc.internal.pageSize.width / 2, 18, { align: 'center' });
      doc.setFontSize(10);
      doc.text(usuario.nombreclub, doc.internal.pageSize.width / 2, 25, { align: 'center' });
      doc.line(20, 26, 204, 26);
      //doc.line(25, 270, 190, 270);
      doc.setFontSize(10);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`resultados`, 14.5, 275, { angle: 90 });
      doc.text(`resultados`, 33.5, 258.5, { angle: -90 });
      doc.addImage(qrResultados, 'png', 15, 258, 18, 18);
      doc.setFontSize(8);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`www.prowebsports.com.co`, 62, 275)
      //doc.text(`PROWEBSPORTS`, 84, 273) 
      doc.text(`+57 324-588-4041`, 65, 272)
      //doc.text(`pws@prowebsports.com.co`, 159, 273)
      doc.addImage(siluetas, 'png', 35, 255, 140, 20);
      doc.addImage(logoImg, 'png', 175, 260, 15, 15);
    };
  
    agregarCabecera();
    data.forEach((obj, indexObj) => {
      doc.setFontSize(10.5);
      doc.setFont('Inter_18pt-Regular', 'normal');
      const text = `${obj.id + 1} ${obj.categoria}`;
      const textPrueba = `${obj.prueba.prueba}`;
      if (y >= doc.internal.pageSize.height - 32) {
        // Cambiar a la siguiente columna o página
        x += columnWidth;
        y = 30;
  
        if (x >= columnWidth * 3) {
          doc.addPage();
          agregarCabecera();
          x = 10;
        }
  
        if(x >= columnWidth * 1 && x <= columnWidth * 2){
          x -= 5;
        }
        if(x >= columnWidth * 2 && x <= columnWidth * 3){
          x -= 4;
        }
      }
  
      doc.setFontSize(10.5);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(x + 29, y, text, {align: 'center'});
      doc.text(x + 29, y + 4.5, textPrueba, {align: 'center'});
      y += 8;
        obj.nadadores.slice(0, nPuestos !== '' ? parseInt(nPuestos) : obj.nadadores.length).forEach((nadador) => {
          doc.setFontSize(7.5);
          doc.setFont('Inter_18pt-Light', 'normal');
          const nadadorText = `${nadador.posicion !== 9999 ? nadador.posicion : '-'}:${acortarNombreClub(nadador.nombre.toString(), 27)}`;
          const tiempo = `${nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : arreglarTiempoEstandar(nadador.tiempo)}` 
          const club = nadador.club.toString().toLowerCase();
    
          if (y >= doc.internal.pageSize.height - 32) {
            // Cambiar a la siguiente columna o página
            x += columnWidth;
            y = 30;
    
            if (x >= columnWidth * 3) {
              doc.addPage();
              agregarCabecera();
              x = 10;
            }
  
            if(x >= columnWidth * 1 && x <= columnWidth * 2){
              x -= 5;
            }
            if(x >= columnWidth * 2 && x <= columnWidth * 3){
              x -= 4;
            }
          }
          doc.setFontSize(7.5);
          doc.setFont('Inter_18pt-Regular', 'normal');
          doc.text(nadador.posicion < 10 || nadador.posicion === 9999 ? x : x - 1.6, y, nadadorText);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(club, x + 44, y, {align: 'left'});
          doc.text(tiempo, x + 52, y, {align: 'left'});
          y += 3.1;

          nadador.equipo && (
            nadador.equipo.forEach((eq, indexEq) =>{
              doc.setFontSize(7.5);
              doc.setFont('Inter_18pt-Light', 'normal');
              const posicion = `${eq}`;

              if (y >= doc.internal.pageSize.height - 32) {
                // Cambiar a la siguiente columna o página
                x += columnWidth;
                y = 30;
    
                if (x >= columnWidth * 3) {
                  doc.addPage();
                  agregarCabecera();
                  x = 10;
                }
  
                if(x >= columnWidth * 1 && x <= columnWidth * 2){
                  x -= 5;
                }
                if(x >= columnWidth * 2 && x <= columnWidth * 3){
                  x -= 4;
                }
              }
              doc.setFontSize(7.5);
              doc.setFont('Inter_18pt-Light', 'normal');
              doc.setTextColor('black');
              doc.text(nadador.posicion < 10 || nadador.posicion === 9999 ? x + 2 : x - 1.6, y, posicion);
              y += 3;
            })
          )
        });
        y += 2;
    });
  
    doc.setProperties({
      title: "Tiempos " + clubPropietario
    });
  
    const generatedPdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(generatedPdfBlob);
    setPdfUrl(pdfUrl);
    toast.dismiss(auxTiempos);
    toast.success('Resultados en formato PDF.');
  }, 500);
}

export function pdfPapeletas(planilla, setPdfUrl, pruebasCompletas, usuario, auxPapeletas, torneoEspecifico) {
  const doc = new jsPDF({
    format: 'letter',
    compress: true,
  });
  const logoImgPws = new Image();
  const logoImgAnfi = new Image();
  logoImgPws.src = require('../img/img-logo-factura.png');
  logoImgAnfi.src = require('../img/img_logo.png');
  const width = 15.5;
  const height = 14;
  const columnWidth = doc.internal.pageSize.width / 2;
  let x = 0;
  let y = 0;

  if (planilla.length === 0) {
    doc.setFontSize(11);
    doc.setFont('Inter_18pt-Regular', 'normal');
    doc.text(usuario.nombreclub + '\nLa programación aún no se ha registrado.', doc.internal.pageSize.width / 2, 48, { align: 'center' });
  } else {
    pruebasCompletas.forEach((obj, indexObj) => {
      obj.forEach((prue, indexPrue)=>{
        if (y >= doc.internal.pageSize.height - 20) {
          // Cambiar a la siguiente columna o página
          x += columnWidth;
          y = 0;
    
          if (x >= columnWidth * 2) {
            doc.addPage();
            x = 0;
          }
        }
  
        doc.setFontSize(12);
        doc.setFont('Inter_18pt-Regular', 'normal');
        // Itera sobre los nadadores en el arreglo `data`
        planilla[prue.id - 1].forEach((nadadorPla, indexNadador) => {

          if (y >= doc.internal.pageSize.height - 20) {
            // Cambiar a la siguiente columna o página
            x += columnWidth;
            y = 0;
  
            if (x >= columnWidth * 2) {
              doc.addPage();
              x = 0;
            }
          }
          doc.setFontSize(12);
          doc.setFont('Inter_18pt-Regular', 'normal');
          nadadorPla.nadadores.forEach((nadador, indexNadador) => {
            if (y >= doc.internal.pageSize.height - 20) {
              // Cambiar a la siguiente columna o página
              x += columnWidth;
              y = 0;
  
              if (x >= columnWidth * 2) {
                doc.addPage();
                x = 0;
              }
            }
            if(nadador.nombre.length !== 0){
              //--------------------------
              //linea izquierda
              doc.line(x, y, x, y + 69.5);
              //linea derecha
              doc.line(x + 107.5, y, x + 107.5, y + 69.5);
              //Fila 1
              doc.line(x, y, x + 107.5, y);
              //logo
              doc.addImage(logoImgAnfi, 'png', x + 4, y + 2, width, height);
              doc.addImage(logoImgPws, 'png', x + 28, y + 2, width, height);
              //linea despues del logo
              doc.line(x + 24, y, x + 24, y + 18);
              doc.line(x + 48, y, x + 48, y + 18);
              doc.setFontSize(14);
              doc.setFont('Inter_18pt-Regular', 'normal');
              doc.text(x + 50, y + 10, 'EVENTO:');
              doc.text(x + 100, y + 10, `${prue.id}`, {align: 'right'});
              //--------------------------
              //Fila 2
              doc.line(x, y + 18, x + 107.5, y + 18);
              doc.setFontSize(13);
              doc.setFont('Inter_18pt-Regular', 'normal');
              doc.text(x + 53.8, y + 25, `${prue.prueba.prueba}`, {align: 'center'});
              //--------------------------
              //Fila 3
              doc.setFont('Inter_18pt-Regular', 'normal');
              doc.setFontSize(13);
              doc.line(x, y + 30, x + 107.5, y + 30);
              doc.text(x + 53.8, y + 38, `${nadador.nombre}`, {align: 'center'});
              //--------------------------
              //Fila 4
              doc.setFontSize(12);
              doc.setFont('Inter_18pt-Regular', 'normal');
              doc.line(x, y + 43, x + 107.5, y + 43);
              doc.text(x + 3, y + 50, 'SERIE:');
              doc.text(x + 50, y + 50, `${nadadorPla.Serie}`, {align: 'right'});
              //linea mitad
              doc.line(x + 53.8, y + 43, x + 53.8, y + 55);
              doc.text(x + 57, y + 50, 'CARRIL:');
              doc.text(x + 100, y + 50, `${nadador.carril}`, {align: 'right'});
              //--------------------------
              //Fila 5
              doc.setFontSize(15);
              doc.line(x, y + 55, x + 107.5, y + 55);
              doc.text(x + 3, y + 64, 'TIEMPO:');
              //--------------------------
              //ultima linea abajo
              doc.line(x, y + 69.5, x + 107.5, y + 69.5);
              y += 70;
            }
          });
        });
      })
    });
      
    doc.setProperties({
      title: "Papeletas " + clubPropietario
    });
  }

  const generatedPdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(generatedPdfBlob);
  setPdfUrl(pdfUrl);
  toast.dismiss(auxPapeletas);
  toast.success('Papeletas creadas correctamente.');
}

export function pdfPruebaIndividual(resultados, detallesTorneo, setPdfUrl){
  const doc = new jsPDF({
    format: 'letter',
    compress: true,
  });
  const logoImg = new Image();
  logoImg.src = require('../img/img_logo.png');
  const width = 22;
  const height = 22;

  // Ajusta las coordenadas para centrar el contenido
  const centerWidth = 4;
  doc.setFont('Times', 'italic', 'bold');
  doc.text(`${resultados.id + 1 + ' / ' + resultados.prueba.prueba + ' / ' + resultados.categoria}`, doc.internal.pageSize.width / 2, 40, { align: 'center' });

  // Define las columnas de la tabla
  const columns = ["Pto", "Deportista", "Edad", "Club", "T.I", "Tiempo"];

  const cellHeight = 15; // Cambia este valor para ajustar el alto de cada celda

  // Itera sobre las columnas y muestra la información en la primera fila
  columns.forEach((column, index) => {
    const yPosition = 43;
    switch (index) {
      case 0:
        doc.text(column, 10, yPosition + cellHeight / 2, { align: 'left' });
        break;
      case 1:
        doc.text(column, 22, yPosition + cellHeight / 2, { align: 'left' });
        break;
      case 2:
        doc.text(column, 90, yPosition + cellHeight / 2, { align: 'left' });
        break;
      case 3:
        doc.text(column, 105, yPosition + cellHeight / 2, { align: 'left' });
        break;
      case 4:
        doc.text(column, 122, yPosition + cellHeight / 2, { align: 'left' });
        break;
      case 5:
        doc.text(column, 138, yPosition + cellHeight / 2, { align: 'left' });
        break;
    
      default:
        break;
    }
  });

  //linea abajo de la categoria y prueba
  doc.line(50, 42, 170, 42);
  //linea debajo del encabezado
  doc.line(8, 53, 190, 53);
  doc.setFontSize(15);
  doc.setFont('Times', 'italic', '');
  // Itera sobre los nadadores y muestra la información en la tabla
  resultados.nadadores.forEach((nadador, index) => {
    const yPosition = 50 + (index + 1) * 5;
    doc.text((nadador.posicion).toString(), centerWidth + 8, yPosition + 5, { align: 'left' });
    doc.text(nadador.nombre, centerWidth + 18, yPosition + 5, { align: 'left' });
    doc.text(nadador.edad, centerWidth + 87, yPosition + 5, { align: 'left' });
    doc.text(nadador.club, centerWidth + 100, yPosition + 5, { align: 'left' });
    doc.text(arreglarTiempoEstandar(nadador.record) !== 'NaN:NaN:NaN' ? '0.0' : arreglarTiempoEstandar(nadador.record), centerWidth + 118, yPosition + 5, { align: 'left' });
    doc.text(`${nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : arreglarTiempoEstandar(nadador.tiempo)}`, centerWidth + 135, yPosition + 5, { align: 'left' });
  });

  doc.setFontSize(10);
  doc.setFont('Times', 'italic');
  doc.text(`${doc.getNumberOfPages()}`, 200, 10)
  doc.setFont('Times', 'italic', 'bold');
  doc.setFontSize(11);
  doc.addImage(logoImg, 'png', 20, 3, width, height);
  doc.text(`${detallesTorneo.titulo}\n${clubPropietario}`, doc.internal.pageSize.width / 2, 10, { align: 'center' });
  doc.setFontSize(8);
  doc.setFont('Times', 'italic');
  doc.text(`${detallesTorneo.direccion}\nPrueba`, doc.internal.pageSize.width / 2, 18, { align: 'center' });
  doc.line(20, 26, 190, 26);
  doc.line(20, 270, 190, 270);
  doc.setFontSize(8);
  doc.setFont('Times', 'italic');
  doc.text(`www.prowebsports.com.co`, 20, 273)
  doc.text(`pws@prowebsports.com.co`, 160, 273)
  doc.text(`PROWEBSPORTS`, 84, 273)
  doc.text(`+57 324-588-4041`, 106, 273)

  doc.setProperties({
    title: `Prueba ${resultados.id + 1 + ' / ' + resultados.prueba.prueba}`
  });

  const generatedPdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(generatedPdfBlob);
  setPdfUrl(pdfUrl);
}

function sacarReporteInscritos(pruebasCompletas, deportistas, nadadoresRelevo){
  const auxDeportistas = [];
  deportistas.forEach((depor)=>{
    depor.reporte = [];
    pruebasCompletas.forEach((jor, indexJor)=>{    
      depor.records.forEach((rec)=>{
        const pruebaEncontrada = jor.filter((prue)=>{return prue.prueba.id === rec.prueba && (parseInt(prue.edadInicio) <= depor.edad && parseInt(prue.edadFin) >= depor.edad) && prue.genero === depor.genero});
        if(pruebaEncontrada.length !== 0){
          depor.auxCategoria = pruebaEncontrada[0].categoria;
          pruebaEncontrada[0].jornada = indexJor + 1;
          depor.reporte.push(pruebaEncontrada[0]);
        }
      })
      if(nadadoresRelevo.length !== 0){
        nadadoresRelevo.forEach((rel) =>{
          const separarIdentificaciones = rel.identificacion.split(',');
          if(separarIdentificaciones.includes(depor.identificacion)){
            const relevoEncontrado = jor.filter((prue)=>{return prue.prueba.id === rel.pruebas[0]});
            if(relevoEncontrado.length !== 0){
              relevoEncontrado[0].jornada = indexJor + 1;
              depor.reporte.push(relevoEncontrado[0]);
            }
          }
        })
      }
    })
    auxDeportistas.push(depor);
  })
  return auxDeportistas;
}

async function loadImageAsBase64ViaFetch(url, genero) {
  const response = await fetch(url && url !== '' ? url : genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp'));
  const responseLocal = await fetch(genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp'));
  const blob = response.ok ? await response.blob() : await responseLocal.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        // Fondo blanco
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // Dibuja imagen encima
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/jpeg', 0.95)); // o 'image/png'
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(blob);
  });
}

export function reporteInscritos(pruebasCompletas, usuario, deportistas, nadadoresRelevo, setPdfUrl, detallesTorneo) {
  const auxReporte = toast.loading('Creando reporte...\nPor favor espera unos segundos.');
  setTimeout(async function() {
    const data = sacarReporteInscritos(pruebasCompletas, deportistas, nadadoresRelevo);
    const doc = new jsPDF({ format: 'letter', compress: true });
    const logoImgPws = new Image();
    const qrResultados = new Image();
    const marco = new Image();
    const logoImg = new Image();
    const siluetas = new Image();
    logoImg.src = require('../img/img_logo.png');
    qrResultados.src = require('../img/qr-resultados.png');
    logoImgPws.src = require('../img/img-logo-factura.png');
    marco.src = require('../img/img-marco.png');
    siluetas.src = require('../img/img-siluetas.png');
  
    const width = 22;
    const height = 22;
    const columnWidth = doc.internal.pageSize.width / 2;
  
    let x = 10;
    let y = 30;
  
    if (data.length === 0) {
      doc.setFontSize(11);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(usuario.nombreclub + '\nNo tienes deportistas inscritos aún.', doc.internal.pageSize.width / 2, 38, { align: 'center' });
    }
  
    // Cabecera común
    const agregarCabecera = () => {
      doc.setFontSize(15);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.addImage(marco, 'png', 0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height);
      doc.text(`${doc.getNumberOfPages() < 10 ? '0' + doc.getNumberOfPages() : doc.getNumberOfPages()}`, 178, 25);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.setFontSize(11);
      doc.addImage(logoImg, 'png', 20, 3, width, height);
      doc.addImage(logoImgPws, 'png', 185, 10, 16, 15);
      doc.text(`${detallesTorneo.titulo}\n${clubPropietario}`, doc.internal.pageSize.width / 2, 10, { align: 'center' });
      doc.setFontSize(8);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`${detallesTorneo.direccion}\nReporte Inscritos`, doc.internal.pageSize.width / 2, 18, { align: 'center' });
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.setFontSize(10);
      doc.text(usuario.nombreclub, doc.internal.pageSize.width / 2, 25, { align: 'center' });
      doc.line(20, 26, 204, 26);
      //doc.line(25, 270, 190, 270);
      doc.setFontSize(10);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`resultados`, 14.5, 275, { angle: 90 });
      doc.text(`resultados`, 33.5, 258.5, { angle: -90 });
      doc.addImage(qrResultados, 'png', 15, 258, 18, 18);
      doc.setFontSize(8);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`www.prowebsports.com.co`, 62, 275)
      //doc.text(`PROWEBSPORTS`, 84, 273) 
      doc.text(`+57 324-588-4041`, 65, 272)
      //doc.text(`pws@prowebsports.com.co`, 159, 273)
      doc.addImage(siluetas, 'png', 35, 255, 140, 20);
      doc.addImage(logoImg, 'png', 175, 260, 15, 15);
    };
  
    agregarCabecera();
  
    for (let indexObj = 0; indexObj < data.length; indexObj++) {
      const obj = data[indexObj];
  
      if ((y + (20 + (obj.reporte.length * 3))) >= doc.internal.pageSize.height - 10) {
        x += columnWidth;
        y = 30;
        if (x >= columnWidth * 2) {
          doc.addPage();
          agregarCabecera();
          x = 10;
        }
      }
  
      const text1 = `${indexObj + 1}) ${obj.auxCategoria || 'Sin pruebas aún'}`;
      const text2 = `DNI: ${obj.identificacion}`;
      const text3 = obj.nombre;

      let altoFoto = 0;
      try {
        const altoTexto = 20;
        const altoMinimo = 20;
        altoFoto = Math.max(altoTexto, altoMinimo);
        const fotoDeportista = await loadImageAsBase64ViaFetch(obj.urlPhoto, obj.genero);
        doc.addImage(fotoDeportista, 'webp', x, y, altoFoto, altoFoto);
      } catch (e) {
        console.error('Error cargando imagen de', obj.nombre);
      }
  
  
      doc.setFontSize(11);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(x + altoFoto + 2, y + 1, text1);
      doc.text(text2, x + altoFoto + 2, y + 5.3);
      doc.text(text3, x + altoFoto + 2, y + 9);
      y += 12;
  
      obj.reporte.sort((a, b) => a.id - b.id);
      obj.reporte.forEach((prue, indexPrue) => {
        doc.setFontSize(8);
        const auxRecord = obj.records.filter((rec) => rec.prueba === prue.prueba.id)[0]?.record ? obj.records.filter((rec) => rec.prueba === prue.prueba.id)[0].record : '0:0:0';
        const pruebaText = `${prue.id}`;
        const textTiempos = `${arreglarTiempoEstandar(auxRecord)}`;
        const textPrueba = `${prue.prueba.prueba}`;
        const textJornada = `Jor: ${prue.jornada}`;
        doc.text(x + altoFoto + 2, y, pruebaText);
        doc.text(textTiempos, x + 10 + altoFoto + 2, y, { align: 'left' });
        doc.text(textJornada, x + 23 + altoFoto + 2, y, { align: 'left' });
        doc.text(textPrueba, x + 33 + altoFoto + 2, y, { align: 'left' });
        y += 3;
      });

      if(obj.reporte.length === 0){
        y+= 11;
      }
      if(obj.reporte.length === 1){
        y+= 9;
      }
      if(obj.reporte.length === 2){
        y+= 7;
      }
      if(obj.reporte.length === 3){
        y+= 3;
      }
    }
  
    doc.setProperties({ title: "Reporte Inscripciones" });
    const generatedPdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(generatedPdfBlob);
    setPdfUrl(pdfUrl);
    toast.dismiss(auxReporte);
    toast.success('Reporte creado correctamente.');
  }, 500);
}

export function clubesInscritosToPdf(clubes, deportistas, setPdfUrl, detallesTorneo, usuario, setDescripcion){
  const auxReporte = toast.loading('Creando reporte...\nPor favor espera unos segundos.');  
  setTimeout(async function() {
    const data = clubes;
    const doc = new jsPDF({
      format: 'letter',
      compress: true,
    });
    const logoImgPws = new Image();
    const qrResultados = new Image();
    const marco = new Image();
    const logoImg = new Image();
    const siluetas = new Image();
    logoImg.src = require('../img/img_logo.png');
    qrResultados.src = require('../img/qr-resultados.png');
    logoImgPws.src = require('../img/img-logo-factura.png');
    marco.src = require('../img/img-marco.png');
    siluetas.src = require('../img/img-siluetas.png');
    const width = 22;
    const height = 22;
    const columnWidth = doc.internal.pageSize.width / 2;
    
    let x = 10;
    let y = 30;

    if(data.length === 0){
      doc.setFontSize(11);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.text(usuario.nombreclub + '\nNo hay clubes inscritos aún.', doc.internal.pageSize.width / 2, 38, { align: 'center' });
    }

    const agregarCabecera = () => {
      doc.setFontSize(15);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.addImage(marco, 'png', 0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height);
      doc.text(`${doc.getNumberOfPages() < 10 ? '0' + doc.getNumberOfPages() : doc.getNumberOfPages()}`, 178, 25);
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.setFontSize(11);
      doc.addImage(logoImg, 'png', 20, 3, width, height);
      doc.addImage(logoImgPws, 'png', 185, 10, 16, 15);
      doc.text(`${detallesTorneo.titulo}\n${clubPropietario}`, doc.internal.pageSize.width / 2, 10, { align: 'center' });
      doc.setFontSize(8);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`${detallesTorneo.direccion}\nReporte Inscritos`, doc.internal.pageSize.width / 2, 18, { align: 'center' });
      doc.setFont('Inter_18pt-Regular', 'normal');
      doc.setFontSize(10);
      doc.line(20, 26, 204, 26);
      //doc.line(25, 270, 190, 270);
      doc.setFontSize(10);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`resultados`, 14.5, 275, { angle: 90 });
      doc.text(`resultados`, 33.5, 258.5, { angle: -90 });
      doc.addImage(qrResultados, 'png', 15, 258, 18, 18);
      doc.setFontSize(8);
      doc.setFont('Inter_18pt-Light', 'normal');
      doc.text(`www.prowebsports.com.co`, 62, 275)
      //doc.text(`PROWEBSPORTS`, 84, 273) 
      doc.text(`+57 324-588-4041`, 65, 272)
      //doc.text(`pws@prowebsports.com.co`, 159, 273)
      doc.addImage(siluetas, 'png', 35, 255, 140, 20);
      doc.addImage(logoImg, 'png', 175, 260, 15, 15);
    };
  
    agregarCabecera();

    data.forEach((obj, indexObj) => {
      if(deportistas.filter((depor)=>depor.nombreclub === obj.nombreclub).length !== 0){
        const text1 = `${obj.nombreclub} - ${obj.pago ? '' : 'Debe'}`;
        if (y >= doc.internal.pageSize.height - 30) {
          // Cambiar a la siguiente columna o página
          x += columnWidth;
          y = 30;
    
          if (x >= columnWidth * 1){
            doc.addPage();
            agregarCabecera();
            x = 10;
          }
        }
  
        doc.setFontSize(13);
        doc.setFont('Inter_18pt-Regular', 'normal');
        doc.text(x + 90, y + 2, text1, {align: 'center'});
        y += 6;
        if(obj.directivos){
          if(obj.directivos.length !== 0){
            obj.directivos.forEach((dire)=>{
              const directivo = `${dire.nombre} : ${dire.rol} : ${dire.cel}`;
              
              doc.setFontSize(13);
              doc.text(x, y + 2, directivo, {align: 'left'});
              y += 5;
            })
  
            y += 4;
          }
        }else{
          y += 2;
        }
  
        deportistas.filter((depor)=>depor.nombreclub === obj.nombreclub).forEach((nadador, indexNadador) => {
          doc.setFontSize(12);
          doc.setFont('Inter_18pt-Light', 'normal');
          const pruebaText = `${indexNadador + 1})`;
          const textNadador = `${nadador.nombre}`
          const textDoc = `${nadador.identificacion}`
          const textFechaNto = `${nadador.fechaNacimiento}`
          const textEdad = `${nadador.edad} Años`
          const textGenero = `${nadador.genero}`
          const verificacion = `${nadador.verificado === 'Verificado' ? 'Verificado' : 'No Verific.'}`
          if (y >= doc.internal.pageSize.height - 30) {
            // Cambiar a la siguiente columna o página
            x += columnWidth;
            y = 30;
    
            if (x >= columnWidth * 1) {
              doc.addPage();
              agregarCabecera();
              x = 10;
            }
          }
          doc.setFontSize(12);
          doc.setFont('Inter_18pt-Light', 'normal');
          doc.text(x, y, pruebaText);
          doc.text(textNadador, (indexNadador + 1) < 10 ? x + 5: (indexNadador + 1) < 100 ? x + 7 : x + 10, y, { align: 'left' });
          doc.text(textDoc, x + 78, y, { align: 'left' });
          doc.text(textFechaNto, x + 108, y, { align: 'left' });
          doc.text(textEdad, x + 135, y, { align: 'left' });
          doc.text(textGenero, x + 155, y, { align: 'left' });
          doc.text(verificacion, x + 178, y, { align: 'left' });
          y += 6;
        });
      }
    })

    doc.setProperties({
      title: "Reporte Inscripciones De Clubes"
    });

    const generatedPdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(generatedPdfBlob);
    setDescripcion('Reporte Inscripciones De Clubes');
    setPdfUrl(pdfUrl);
    toast.dismiss(auxReporte);
    toast.success('Reporte creado correctamente.');
  },500);
}